import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { exportFecReport } from '../services/query-api'

interface UseExportFecReportProps {
  onError?: (error?: APIError) => void
  onSettled?: (data: void, error: APIError | null | undefined) => void
  onSuccess?: (data: void) => void
}

export const useExportFecReport = (props?: UseExportFecReportProps) => {
  const { onError, onSuccess, onSettled } = props || {}
  const { mutate, ...rest } = useMutation(exportFecReport, {
    onSuccess,
    onError,
    onSettled,
  })

  return { mutate, ...rest }
}
